module.exports = __webpack_public_path__ + "media/images/social/linkedin-a72e486193bf68634eec213e4dd26907.svg";